import React, { useState } from "react";

import styles from "../../../../styles/pages/user/managerdashboard/verifidvideosdenied.module.scss";

import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import { Box } from "@mui/system";
import { Button, Tab, TableContainer, Tabs, Typography } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import PendingPublicationIcon from "../../../../public/assets/icons/PendingPublicationIcon";
import PublishedVideoIcon from "../../../../public/assets/icons/PublishedVideoIcon";
import OpenMessageIcon from "../../../../public/assets/icons/OpenMessageIcon";
import CalenderIcon from "../../../../public/assets/icons/CalenderIcon";
import ApprovedVideoIcon from "../../../../public/assets/icons/ApprovedVideoIcon";
import WebsiteIcon from "../../../../public/assets/icons/WebsiteIcon";
import RejectedVideoIcon from "../../../../public/assets/icons/RejectedVideoIcon";
import ReviewVideoFilter from "../../../../components/ReviewdVideoFilter/ReviewVideoFilter";
import ApprovedVideoTable from "../../../../components/ApprovedvideoTable/ApprovedVideoTable";
import ReviewdVideoMenu from "../../../../components/ReviewdVideoMenu/ReviewdVideoMenu";
import WebsiteVideoTable from "../../../../components/WebsiteVideoTable/WebsiteVideoTable";
import VerifiedVideoMenu from "../../../../components/VerifiedVideoMenu/VerifiedVideoMenu";
import TabArrow from "../../../../public/assets/icons/TabArrow";
import VerifiedConfirmApprovedTable from "../../../../components/VerifiedConfirmApprovedTable/VerifiedConfirmApprovedTable";
import VerifyConfrmApprvFilter from "../../../../components/VerifyConfrmApprvFilter/VerifyConfrmApprvFilter";
import VerifiedConfirmedWebsiteTable from "../../../../components/VerifiedConfirmedWebsiteTable/VerifiedConfirmedWebsiteTable";
import VerifyConfrmWebsiteFilter from "../../../../components/VerifyConfrmWebsiteFilter/VerifyConfrmWebsiteFilter";
import VerifiedConfirmedRejectedTable from "../../../../components/VerifiedConfirmedRejectedTable/VerifiedConfirmedRejectedTable";
import VerifyConfirmedRejectedFilter from "../../../../components/VerifyConfirmedRejectedFilter/VerifyConfirmedRejectedFilter";
import VerifyDeniedApproveRejectTable from "../../../../components/VerifyDeniedApproveRejectTable.jsx/VerifyDeniedApproveRejectTable";
import VerifyDeniedApproveRejectfilter from "../../../../components/VerifyDeniedApproveRejectfilter/VerifyDeniedApproveRejectfilter";
import VerifyDeniedApproveWebsiteTable from "../../../../components/VerifyDeniedApproveWebsiteTable/VerifyDeniedApproveWebsiteTable";
import VerifyDeniedApproveWebsiteFilter from "../../../../components/VerifyDeniedApproveWebsiteFilter/VerifyDeniedApproveWebsiteFilter";
import VerifyDeniedRejectedApprovedTable from "../../../../components/VerifyDeniedRejectedApprovedTable/VerifyDeniedRejectedApprovedTable";
import VerifyDeniedRejectedApproveFilter from "../../../../components/VerifyDeniedRejectedApproveFilter/VerifyDeniedRejectedApproveFilter";
import VerifyDeniedRejectedWebsiteTable from "../../../../components/VerifyDeniedRejectedWebsiteTable/VerifyDeniedRejectedWebsiteTable";
import VerifyDeniedRejectedWebsiteFilter from "../../../../components/VerifyDeniedRejectedWebsiteFilter/VerifyDeniedRejectedWebsiteFilter";
import VerifyDeniedWebsiteApprovedTable from "../../../../components/VerifyDeniedWebsiteApprovedTable/VerifyDeniedWebsiteApprovedTable";
import VerifyDeniedWebsiteApprovedFilter from "../../../../components/VerifyDeniedWebsiteApprovedFilter/VerifyDeniedWebsiteApprovedFilter";
import VerifyDeniedWebsiteRejectedTable from "../../../../components/VerifyDeniedWebsiteRejectedTable/VerifyDeniedWebsiteRejectedTable";
import VerifyDeniedWebsiteRejectedFilter from "../../../../components/VerifyDeniedWebsiteRejectedFilter/VerifyDeniedWebsiteRejectedFilter";
import { usePost } from "../../../../hooks/api/useFetch";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function VerifiedVideoDenied() {
    const [value, setValue] = React.useState(0);
    const [managerDecision, setManagerDecision] = useState(1);
    const [qualityTeamDecision, setQualityTeamDecision] = useState(1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setManagerDecision(
            newValue === 0
                ? 1
                : newValue === 1
                ? 1
                : newValue === 2
                ? 2
                : newValue === 3
                ? 2
                : 5
        );
        setManagerDecision(
            newValue === 0
                ? 2
                : newValue === 1
                ? 5
                : newValue === 2
                ? 1
                : newValue === 3
                ? 5
                : newValue === 4
                ? 1
                : 2
        );
    };

    /*************************************/

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [buyerId, setBuyerId] = useState("");
    const [calanderDate, setCalenderDate] = useState({ from: "", to: "" });
    const [dateFilter, setDateFilter] = useState({
        from: "",
        to: "",
    });
    const handleDateFilter = (dates) => {
        const { startDate, endDate } = dates;
        setDateFilter({ from: startDate, to: endDate });
    };
    const [videoCountry, setVideoCountry] = useState("");
    const [filterParams, setFilterParams] = useState(null);
    const resetFilterparams = () => {
        setFilterParams(null);
        setDateFilter({
            from: "",
            to: "",
        });
        setVideoCountry("");
        setBuyerId("");
    };
    const [page, setPage] = useState(1);
    const handlePageChange = (e) => {
        setPage(e);
    };
    const {
        data: managerVideos,
        isSuccess: managerVideosIsSuccess,
        isLoading: managerVideosIsLoading,
        isError: managerVideosIsError,
        refetch: managerVideosRefetch,
    } = usePost(
        [
            "manager-verified-videos",
            managerDecision,
            qualityTeamDecision,
            buyerId,
            filterParams,
            calanderDate,
            dateFilter,
            videoCountry,
            page,
        ],
        "/manager/videos",
        {
            buyerId: buyerId,
            from: dateFilter?.from ? dateFilter?.from : calanderDate?.from,
            to: dateFilter?.to ? dateFilter?.to : calanderDate?.to,
            manager_decision: managerDecision,
            quality_team_decision: qualityTeamDecision,
            location: videoCountry,
            ...filterParams,
            page: page,
        }
    );

    return (
        <ManagerDashboardWapper>
            <Box className={styles.reviewd_videos_wrapper}>
                <Box className={styles.reviewVideoMenu}>
                    <VerifiedVideoMenu />
                </Box>

                <Box className={styles.video_tab}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                    >
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Approved
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Rejected
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(0)}
                        />
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Approved
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Website Only
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(1)}
                        />
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Rejected
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Approved
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(2)}
                        />
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Rejected
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Website Only
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(3)}
                        />
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Website Only
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Approved
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(4)}
                        />
                        <Tab
                            label={
                                <>
                                    <Box className={styles.tabItem}>
                                        <Typography variant="caption">
                                            Website Only
                                        </Typography>
                                        <figure>
                                            <TabArrow />
                                        </figure>
                                        <Typography variant="caption">
                                            Rejected
                                        </Typography>
                                    </Box>
                                </>
                            }
                            {...a11yProps(5)}
                        />
                    </Tabs>
                </Box>

                <Box className={styles.reviewVideoTabMain}>
                    <CustomTabPanel value={value} index={0}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedApproveRejectfilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedApproveRejectTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedApproveWebsiteFilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedApproveWebsiteTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={2}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedRejectedApproveFilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedRejectedApprovedTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={3}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedRejectedWebsiteFilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedRejectedWebsiteTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={4}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedWebsiteApprovedFilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedWebsiteApprovedTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={5}>
                        <Box className={styles.single_rreview_tab}>
                            <Box className={styles.reviewd_filter_wrap}>
                                <VerifyDeniedWebsiteRejectedFilter
                                    buyerId={buyerId}
                                    setBuyerId={setBuyerId}
                                    totalVideos={managerVideos?.data?.total}
                                    currentFilterParams={filterParams}
                                    videoCountry={videoCountry}
                                    setVideoCountry={setVideoCountry}
                                    dateFilter={dateFilter}
                                    handleDateFilter={handleDateFilter}
                                    handleFilter={setFilterParams}
                                    setCalenderDate={setCalenderDate}
                                />
                            </Box>

                            <Box className={styles.approved_videos_table_wrap}>
                                <VerifyDeniedWebsiteRejectedTable
                                    managerVideos={managerVideos}
                                    managerVideosIsSuccess={
                                        managerVideosIsSuccess
                                    }
                                    managerVideosIsLoading={
                                        managerVideosIsLoading
                                    }
                                    handlePageChange={handlePageChange}
                                    resetFilterparams={resetFilterparams}
                                    filterParams={filterParams}
                                    videoCountry={videoCountry}
                                    calanderDate={calanderDate}
                                />
                            </Box>
                        </Box>
                    </CustomTabPanel>
                </Box>
            </Box>
        </ManagerDashboardWapper>
    );
}
